import {
  acceptPreview,
  clearPreview,
  generateDraftFailure,
  generateDraftRequest,
  generateDraftSuccess,
  rejectPreview,
  rephraseFailure,
  rephraseRequest,
  rephraseSuccess,
} from './reducers';

export {
  acceptPreview,
  clearPreview,
  generateDraftFailure,
  generateDraftRequest,
  generateDraftSuccess,
  rejectPreview,
  rephraseFailure,
  rephraseRequest,
  rephraseSuccess,
};

export const GENERATE_DRAFT_REQUEST = generateDraftRequest.type;
export const GENERATE_DRAFT_SUCCESS = generateDraftSuccess.type;
export const GENERATE_DRAFT_FAILURE = generateDraftFailure.type;
export const REPHRASE_REQUEST = rephraseRequest.type;
export const REPHRASE_SUCCESS = rephraseSuccess.type;
export const REPHRASE_FAILURE = rephraseFailure.type;
export const ACCEPT_PREVIEW = acceptPreview.type;
export const REJECT_PREVIEW = rejectPreview.type;
export const CLEAR_PREVIEW = clearPreview.type;
